import axios from "axios";
import { Alert } from "../components";
import { ClearSession } from "../utils";
import { persistence } from "../store/persistence";

export const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      let err = error;
      console.log("NetworkError: ", error);
      if(error?.response?.status === 500) return null //Doesnt show auth alert
      if (
        error?.response?.status === 401 ||
        error?.code === 401 ||
        error?.message === "Network Error"
      ) {
        err = error.message;
        Alert(
          {
            icon: "error",
            title: "Error de autentificación, inicia sesión nuevamente",
            allowOutsideClick: false,
            allowEscapeKey: false,
          },
          (res) => {
            if (res?.isConfirmed) {
              ClearSession();
              persistence.EndSession();
              window.location.href = "/auth/";
              // dispatch(fileActions.GetFileInfo(null, true)); //Moved to login component
            }
          }
        );
      }
      return Promise.reject(err);
    }
  );
};
